export class DataPersRowToValidateDTO{
    constructor(){
        this.CodicePers,
        this.CodicePosizioneStampa,
        this.QtaPezzi
    }
}